module.exports = __webpack_public_path__ + "so.dc2fb9be.svg";